import {
  ItemGridToolbar as ItemGridToolbarGenric,
  type ItemGridToolbarProps as ItemGridToolbarPropsGeneric,
} from "@package/ui-apollo-components";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  ITEM_GRID_PATH_EDIT,
  ITEM_GRID_PATH_NEW,
} from "../../constants/contants";
import {
  setItemGridSelectedItemId,
  type SliceItemGridState,
} from "../../store/slices/slice-item-grid";
import { useAppDispatch, useAppSelector } from "../../store/store";

export type ItemGridToolbarProps = Pick<
  ItemGridToolbarPropsGeneric,
  | "createEnabled"
  | "deleteDocument"
  | "deleteEnabled"
  | "deleteRefetchQueries"
  | "editEnabled"
  | "exportEnabled"
  | "title"
> & {
  sidebarEntryPath: keyof SliceItemGridState;
};

export function ItemGridToolbar({
  sidebarEntryPath,
  ...props
}: ItemGridToolbarProps) {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const selectedItemId = useAppSelector(
    (state) => state.itemGrid[sidebarEntryPath].selectedItemId,
  );

  const onCreateClicked = useCallback(() => {
    navigate(`/${sidebarEntryPath}/${ITEM_GRID_PATH_NEW}${search}`);
  }, [navigate, search, sidebarEntryPath]);
  const onEditClicked = useCallback(
    (id?: string) => {
      navigate(`/${sidebarEntryPath}/${ITEM_GRID_PATH_EDIT}/${id}${search}`);
    },
    [navigate, search, sidebarEntryPath],
  );
  const onSelectedItemIdChanged = useCallback(
    (id?: string) => {
      dispatch(
        setItemGridSelectedItemId({
          path: sidebarEntryPath,
          id,
        }),
      );
    },
    [dispatch, sidebarEntryPath],
  );

  return (
    <ItemGridToolbarGenric
      {...props}
      onCreateClicked={onCreateClicked}
      onEditClicked={onEditClicked}
      onSelectedItemIdChanged={onSelectedItemIdChanged}
      selectedItemId={selectedItemId}
    />
  );
}
